import Repository from "../Repository";

const resource = "/bo/articles";

export default {
  /**
   * Get all articles
   */
  get() {
    return Repository.get(`${resource}/all`);
  },

  /**
   * Create an article
   */
  create(payload) {
    return Repository.post(`${resource}`, payload);
  },

  /**
   * Get an article
   */
  getArticle(articleId) {
    return Repository.get(`${resource}/${articleId}`);
  },

  /**
   * Update an article
   */
  updateArticle(articleId, payload) {
    return Repository.put(`${resource}/${articleId}`, payload);
  },

  /**
   * Delete an article
   */
  deleteArticle(articleId) {
    return Repository.delete(`${resource}/${articleId}`);
  }
};
